import { createStyles } from '@mantine/core'

export default createStyles((theme) => ({
  homepageLogoContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    float: 'left',
    marginRight: '45px',
    backgroundColor: 'transparent',
    zIndex: 557,
    marginLeft: '0px',
    [theme.fn.smallerThan(993)]: {
      marginRight: '5px',
    },
  },
  loader: {
    [theme.fn.largerThan(680)]: {
      transform: 'scale(.5, .5)',
      marginLeft: '0px',
    },
    [theme.fn.smallerThan(993)]: {
      transform: 'scale(.5, .5) translate(-19px,0px)',
      marginTop: '25px',
      marginLeft: '-20px',
    },
    [theme.fn.smallerThan(670)]: {
      marginLeft: '35px',
    },
    [theme.fn.smallerThan(660)]: {
      marginLeft: '35px',
    },
    [theme.fn.smallerThan(650)]: {
      marginLeft: '35px',
    },
    [theme.fn.smallerThan(640)]: {
      marginLeft: '35px',
    },
    [theme.fn.smallerThan(630)]: {
      marginLeft: '35px',
    },
    [theme.fn.smallerThan(620)]: {
      marginLeft: '35px',
    },
    [theme.fn.smallerThan(610)]: {
      marginLeft: '35px',
    },
    [theme.fn.smallerThan(600)]: {
      marginLeft: '35px',
    },
    [theme.fn.smallerThan(590)]: {
      marginLeft: '50px',
    },
    [theme.fn.smallerThan(580)]: {
      marginLeft: '45px',
    },
    [theme.fn.smallerThan(570)]: {
      marginLeft: '40px',
    },
    [theme.fn.smallerThan(560)]: {
      marginLeft: '35px',
    },
    [theme.fn.smallerThan(550)]: {
      marginLeft: '30px',
    },
    [theme.fn.smallerThan(540)]: {
      marginLeft: '25px',
    },
    [theme.fn.smallerThan(530)]: {
      marginLeft: '20px',
    },
    [theme.fn.smallerThan(520)]: {
      marginLeft: '15px',
    },
    [theme.fn.smallerThan(510)]: {
      marginLeft: '10px',
    },
    [theme.fn.smallerThan(500)]: {
      marginLeft: '5px',
    },
    [theme.fn.smallerThan(490)]: {
      marginLeft: '0px',
    },
    [theme.fn.smallerThan(480)]: {
      marginLeft: '-5px',
    },
    [theme.fn.smallerThan(470)]: {
      marginLeft: '-10px',
    },
    [theme.fn.smallerThan(460)]: {
      marginLeft: '-15px',
    },
    [theme.fn.smallerThan(450)]: {
      marginLeft: '-20px',
    },
    [theme.fn.smallerThan(440)]: {
      marginLeft: '-25px',
    },
    [theme.fn.smallerThan(430)]: {
      marginLeft: '-30px',
    },
    [theme.fn.smallerThan(420)]: {
      marginLeft: '-35px',
    },
    [theme.fn.smallerThan(410)]: {
      marginLeft: '-40px',
    },
    [theme.fn.smallerThan(400)]: {
      marginLeft: '-45px',
    },
    [theme.fn.smallerThan(390)]: {
      marginLeft: '-50px',
    },
    [theme.fn.smallerThan(380)]: {
      marginLeft: '-55px',
    },
    [theme.fn.smallerThan(370)]: {
      marginLeft: '-60px',
    },
    [theme.fn.smallerThan(360)]: {
      marginLeft: '-65px',
    },
    [theme.fn.smallerThan(350)]: {
      marginLeft: '-70px',
    },
    [theme.fn.smallerThan(340)]: {
      marginLeft: '-75px',
    },
    [theme.fn.smallerThan(330)]: {
      marginLeft: '-80px',
    },
    [theme.fn.smallerThan(320)]: {
      marginLeft: '-85px',
    },
    [theme.fn.smallerThan(310)]: {
      transform: 'scale(.5, .5) translate(-30px,0px)',
      marginLeft: '-90px',
    },
    [theme.fn.smallerThan(300)]: {
      marginLeft: '-95px',
    },
  },
  loaderIphonePortrait: {
    [theme.fn.largerThan(680)]: {
      transform: 'scale(.5, .5)',
      marginLeft: '0px',
    },
    [theme.fn.smallerThan(993)]: {
      transform: 'scale(.5, .5) translate(-19px,-100px)',
      marginTop: '25px',
      marginLeft: '-20px',
    },
    [theme.fn.smallerThan(670)]: {
      marginLeft: '35px',
    },
    [theme.fn.smallerThan(590)]: {
      marginLeft: '50px',
    },
    [theme.fn.smallerThan(580)]: {
      marginLeft: '45px',
    },
    [theme.fn.smallerThan(570)]: {
      marginLeft: '40px',
    },
    [theme.fn.smallerThan(560)]: {
      marginLeft: '35px',
    },
    [theme.fn.smallerThan(550)]: {
      marginLeft: '30px',
    },
    [theme.fn.smallerThan(540)]: {
      marginLeft: '25px',
    },
    [theme.fn.smallerThan(530)]: {
      marginLeft: '20px',
    },
    [theme.fn.smallerThan(520)]: {
      marginLeft: '15px',
    },
    [theme.fn.smallerThan(510)]: {
      marginLeft: '10px',
    },
    [theme.fn.smallerThan(500)]: {
      marginLeft: '5px',
    },
    [theme.fn.smallerThan(490)]: {
      marginLeft: '0px',
    },
    [theme.fn.smallerThan(480)]: {
      marginLeft: '-5px',
    },
    [theme.fn.smallerThan(470)]: {
      marginLeft: '-10px',
    },
    [theme.fn.smallerThan(460)]: {
      marginLeft: '-15px',
    },
    [theme.fn.smallerThan(450)]: {
      marginLeft: '-20px',
    },
    [theme.fn.smallerThan(440)]: {
      marginLeft: '-25px',
    },
    [theme.fn.smallerThan(430)]: {
      marginLeft: '-30px',
    },
    [theme.fn.smallerThan(420)]: {
      marginLeft: '-35px',
    },
    [theme.fn.smallerThan(410)]: {
      marginLeft: '-40px',
    },
    [theme.fn.smallerThan(400)]: {
      marginLeft: '-45px',
    },
    [theme.fn.smallerThan(390)]: {
      marginLeft: '-50px',
    },
    [theme.fn.smallerThan(380)]: {
      marginLeft: '-55px',
    },
    [theme.fn.smallerThan(370)]: {
      marginLeft: '-60px',
    },
    [theme.fn.smallerThan(360)]: {
      marginLeft: '-65px',
    },
    [theme.fn.smallerThan(350)]: {
      marginLeft: '-70px',
    },
    [theme.fn.smallerThan(340)]: {
      marginLeft: '-75px',
    },
    [theme.fn.smallerThan(330)]: {
      marginLeft: '-80px',
    },
    [theme.fn.smallerThan(320)]: {
      marginLeft: '-85px',
    },
    [theme.fn.smallerThan(310)]: {
      transform: 'scale(.5, .5) translate(-30px,-100px)',
      marginLeft: '-90px',
    },
    [theme.fn.smallerThan(300)]: {
      marginLeft: '-95px',
    },
  },
  audioWrapper: {
    top: 0,
    position: 'fixed',
    zIndex: 56,
  },
  imgLogo: {
    maxWidth: '70px',
    display: 'inline-block',
    transform: 'scale(3, 3)',
    marginLeft: '40px',
    marginTop: '-70px',
    zIndex: 56,
    cursor: 'pointer',
    '&:hover': {
      opacity: 0.8,
    },
    [theme.fn.smallerThan(993)]: {
      maxWidth: '40px',
      marginLeft: '5px',
      marginTop: '-65px',
    },
  },
  imgLogoNoHover: {
    maxWidth: '70px',
    display: 'inline-block',
    transform: 'scale(3, 3)',
    marginLeft: '40px',
    marginTop: '-70px',
    zIndex: 56,
    cursor: 'pointer',
    [theme.fn.smallerThan(993)]: {
      maxWidth: '40px',
      marginLeft: '5px',
      marginTop: '-65px',
    },
  },
  audioAndLogoHeader: {
    display: 'flex',
    width: '55%',
    left: 0,
    top: 0,
    marginLeft: '0px',
    zIndex: 1000,
    [theme.fn.smallerThan(1670)]: {
      width: '30%',
    },
    [theme.fn.smallerThan(1400)]: {
      width: '60%',
    },
    [theme.fn.smallerThan(1300)]: {
      width: '90%',
    },
    [theme.fn.smallerThan(993)]: {
      width: '95%',
    },
    [theme.fn.smallerThan(850)]: {
      width: '85%',
    },
    [theme.fn.smallerThan(730)]: {
      width: '75%',
    },
  },
  buttonPlayerFavorite: {
    zIndex: 1,
    top: 20,
    left: 230,
    width: '25px',
    height: '25px',
    backgroundColor: 'transparent',
    [theme.fn.smallerThan(993)]: {
      left: 135,
    },
    [theme.fn.smallerThan(641)]: {
      left: 17,
      top: 19.25,
      width: '32px',
      height: '32px',
    },
    [theme.fn.smallerThan(401)]: {
      top: 15.25,
    },
  },
  buttonPlayerPlaylist: {
    zIndex: 1,
    left: 265,
    top: 20,
    width: '25px',
    height: '25px',
    backgroundColor: 'transparent',
    [theme.fn.smallerThan(993)]: {
      left: 174,
    },
    [theme.fn.smallerThan(641)]: {
      left: 55,
      top: 19.25,
      width: '32px',
      height: '32px',
    },
    [theme.fn.smallerThan(401)]: {
      left: 50,
      top: 15.25,
    },
  },
  animatedSongName_Mobile: {
    zIndex: 1,
    position: 'absolute',
    left: 305,
    top: 22,
    fontStyle: 'italic',
    width: '1075px',
    height: '30px',
    [theme.fn.smallerThan(2166)]: {
      width: '1075px',
    },
    [theme.fn.smallerThan(2135)]: {
      width: '1020px',
    },
    [theme.fn.smallerThan(2100)]: {
      width: '1005px',
    },
    [theme.fn.smallerThan(2075)]: {
      width: '990px',
    },
    [theme.fn.smallerThan(2050)]: {
      width: '975px',
    },
    [theme.fn.smallerThan(2025)]: {
      width: '965px',
    },
    [theme.fn.smallerThan(2000)]: {
      width: '955px',
    },
    [theme.fn.smallerThan(1975)]: {
      width: '945px',
    },
    [theme.fn.smallerThan(1950)]: {
      width: '925px',
    },
    [theme.fn.smallerThan(1925)]: {
      width: '910px',
    },
    [theme.fn.smallerThan(1900)]: {
      width: '900px',
    },
    [theme.fn.smallerThan(1850)]: {
      width: '870px',
    },
    [theme.fn.smallerThan(1775)]: {
      width: '820px',
    },
    [theme.fn.smallerThan(1750)]: {
      width: '810px',
    },
    [theme.fn.smallerThan(1725)]: {
      width: '800px',
    },
    [theme.fn.smallerThan(1700)]: {
      width: '790px',
    },
    [theme.fn.smallerThan(1686)]: {
      width: '665px',
    },
    [theme.fn.smallerThan(1656)]: {
      width: '635px',
    },
    [theme.fn.smallerThan(1600)]: {
      width: '625px',
    },
    [theme.fn.smallerThan(1575)]: {
      width: '610px',
    },
    [theme.fn.smallerThan(1550)]: {
      width: '595px',
    },
    [theme.fn.smallerThan(1525)]: {
      width: '580px',
    },
    [theme.fn.smallerThan(1500)]: {
      width: '570px',
    },
    [theme.fn.smallerThan(1475)]: {
      width: '555px',
    },
    [theme.fn.smallerThan(1450)]: {
      width: '535px',
    },
    [theme.fn.smallerThan(1425)]: {
      width: '525px',
    },
    [theme.fn.smallerThan(1401)]: {
      width: '500px',
    },
    [theme.fn.smallerThan(1400)]: {
      width: '485px',
    },
    [theme.fn.smallerThan(1375)]: {
      width: '470px',
    },
    [theme.fn.smallerThan(1335)]: {
      width: '445px',
    },
    [theme.fn.smallerThan(1301)]: {
      width: '620px',
    },
    [theme.fn.smallerThan(1250)]: {
      width: '620px',
    },
    [theme.fn.smallerThan(1225)]: {
      width: '605px',
    },
    [theme.fn.smallerThan(1215)]: {
      width: '600px',
    },
    [theme.fn.smallerThan(1200)]: {
      width: '460px',
    },
    [theme.fn.smallerThan(1175)]: {
      width: '450px',
    },
    [theme.fn.smallerThan(1150)]: {
      width: '440px',
    },
    [theme.fn.smallerThan(1125)]: {
      width: '430px',
    },
    [theme.fn.smallerThan(1100)]: {
      width: '420px',
    },
    [theme.fn.smallerThan(1085)]: {
      width: '410px',
    },
    [theme.fn.smallerThan(1060)]: {
      width: '400px',
    },
    [theme.fn.smallerThan(1050)]: {
      width: '390px',
    },
    [theme.fn.smallerThan(1025)]: {
      width: '380px',
    },
    [theme.fn.smallerThan(993)]: {
      left: 210,
      width: '635px',
    },
    [theme.fn.smallerThan(970)]: {
      width: '605px',
    },
    [theme.fn.smallerThan(950)]: {
      width: '595px',
    },
    [theme.fn.smallerThan(940)]: {
      width: '585px',
    },
    [theme.fn.smallerThan(920)]: {
      width: '565px',
    },
    [theme.fn.smallerThan(895)]: {
      width: '545px',
    },
    [theme.fn.smallerThan(885)]: {
      width: '535px',
    },
    [theme.fn.smallerThan(870)]: {
      width: '510px',
    },
    [theme.fn.smallerThan(860)]: {
      width: '503px',
    },
    [theme.fn.smallerThan(845)]: {
      width: '490px',
    },
    [theme.fn.smallerThan(825)]: {
      width: '470px',
    },
    [theme.fn.smallerThan(813)]: {
      width: '455px',
    },
    [theme.fn.smallerThan(800)]: {
      width: '445px',
    },
    [theme.fn.smallerThan(789)]: {
      width: '437px',
    },
    [theme.fn.smallerThan(775)]: {
      width: '420px',
    },
    [theme.fn.smallerThan(765)]: {
      width: '410px',
    },
    [theme.fn.smallerThan(750)]: {
      width: '400px',
    },
    [theme.fn.smallerThan(740)]: {
      width: '387px',
    },
    [theme.fn.smallerThan(730)]: {
      width: '375px',
    },
    [theme.fn.smallerThan(710)]: {
      width: '360px',
    },
    [theme.fn.smallerThan(695)]: {
      width: '335px',
    },
    [theme.fn.smallerThan(680)]: {
      width: '325px',
    },
    [theme.fn.smallerThan(665)]: {
      width: '305px',
    },
    [theme.fn.smallerThan(641)]: {
      left: 85,
      top: 23,
      width: '420px',
    },
    [theme.fn.smallerThan(625)]: {
      width: '405px',
    },
    [theme.fn.smallerThan(605)]: {
      width: '380px',
    },
    [theme.fn.smallerThan(590)]: {
      width: '370px',
    },
    [theme.fn.smallerThan(575)]: {
      width: '360px',
    },
    [theme.fn.smallerThan(567)]: {
      width: '349px',
    },
    [theme.fn.smallerThan(560)]: {
      width: '340px',
    },
    [theme.fn.smallerThan(552)]: {
      width: '335px',
    },
    [theme.fn.smallerThan(545)]: {
      width: '330px',
    },
    [theme.fn.smallerThan(538)]: {
      width: '324px',
    },
    [theme.fn.smallerThan(530)]: {
      width: '305px',
    },
    [theme.fn.smallerThan(515)]: {
      width: '298px',
    },
    [theme.fn.smallerThan(508)]: {
      width: '292px',
    },
    [theme.fn.smallerThan(500)]: {
      width: '283px',
    },
    [theme.fn.smallerThan(485)]: {
      width: '265px',
    },
    [theme.fn.smallerThan(475)]: {
      width: '257px',
    },
    [theme.fn.smallerThan(460)]: {
      width: '240px',
    },
    [theme.fn.smallerThan(450)]: {
      width: '239px',
    },
    [theme.fn.smallerThan(442)]: {
      width: '226px',
    },
    [theme.fn.smallerThan(437)]: {
      width: '224px',
    },
    [theme.fn.smallerThan(427)]: {
      width: '210px',
    },
    [theme.fn.smallerThan(420)]: {
      width: '204px',
    },
    [theme.fn.smallerThan(410)]: {
      width: '195px',
    },
    [theme.fn.smallerThan(401)]: {
      top: 21,
      fontSize: '12px',
      width: '199px',
    },
    [theme.fn.smallerThan(395)]: {
      top: 21,
      fontSize: '12px',
      width: '193px',
    },
    [theme.fn.smallerThan(390)]: {
      width: '180px',
    },
    [theme.fn.smallerThan(380)]: {
      width: '170px',
    },
    [theme.fn.smallerThan(370)]: {
      width: '165px',
    },
    [theme.fn.smallerThan(365)]: {
      width: '160px',
    },
    [theme.fn.smallerThan(360)]: {
      width: '155px',
    },
    [theme.fn.smallerThan(355)]: {
      width: '178px',
    },
    [theme.fn.smallerThan(345)]: {
      width: '173px',
    },
    [theme.fn.smallerThan(337)]: {
      width: '160px',
    },
    [theme.fn.smallerThan(330)]: {
      width: '160px',
    },
    [theme.fn.smallerThan(325)]: {
      width: '150px',
    },
    [theme.fn.smallerThan(320)]: {
      width: '150px',
    },
    [theme.fn.smallerThan(310)]: {
      width: '136px',
    },
    [theme.fn.smallerThan(300)]: {
      width: '120px',
    },
    [theme.fn.smallerThan(285)]: {
      width: '110px',
    },
    [theme.fn.smallerThan(275)]: {
      width: '105px',
    },
  },
  animatedSongName: {
    zIndex: 1,
    position: 'absolute',
    left: 305,
    top: 22,
    fontStyle: 'italic',
    width: '1075px',
    height: '30px',
    [theme.fn.smallerThan(2166)]: {
      width: '1075px',
    },
    [theme.fn.smallerThan(2135)]: {
      width: '1020px',
    },
    [theme.fn.smallerThan(2100)]: {
      width: '1005px',
    },
    [theme.fn.smallerThan(2075)]: {
      width: '990px',
    },
    [theme.fn.smallerThan(2050)]: {
      width: '975px',
    },
    [theme.fn.smallerThan(2025)]: {
      width: '965px',
    },
    [theme.fn.smallerThan(2000)]: {
      width: '955px',
    },
    [theme.fn.smallerThan(1975)]: {
      width: '945px',
    },
    [theme.fn.smallerThan(1950)]: {
      width: '925px',
    },
    [theme.fn.smallerThan(1925)]: {
      width: '910px',
    },
    [theme.fn.smallerThan(1900)]: {
      width: '900px',
    },
    [theme.fn.smallerThan(1850)]: {
      width: '870px',
    },
    [theme.fn.smallerThan(1775)]: {
      width: '820px',
    },
    [theme.fn.smallerThan(1750)]: {
      width: '810px',
    },
    [theme.fn.smallerThan(1725)]: {
      width: '800px',
    },
    [theme.fn.smallerThan(1700)]: {
      width: '790px',
    },
    [theme.fn.smallerThan(1686)]: {
      width: '665px',
    },
    [theme.fn.smallerThan(1656)]: {
      width: '635px',
    },
    [theme.fn.smallerThan(1600)]: {
      width: '625px',
    },
    [theme.fn.smallerThan(1575)]: {
      width: '610px',
    },
    [theme.fn.smallerThan(1550)]: {
      width: '595px',
    },
    [theme.fn.smallerThan(1525)]: {
      width: '580px',
    },
    [theme.fn.smallerThan(1500)]: {
      width: '570px',
    },
    [theme.fn.smallerThan(1475)]: {
      width: '555px',
    },
    [theme.fn.smallerThan(1450)]: {
      width: '535px',
    },
    [theme.fn.smallerThan(1425)]: {
      width: '525px',
    },
    [theme.fn.smallerThan(1401)]: {
      width: '500px',
    },
    [theme.fn.smallerThan(1400)]: {
      width: '485px',
    },
    [theme.fn.smallerThan(1375)]: {
      width: '470px',
    },
    [theme.fn.smallerThan(1335)]: {
      width: '445px',
    },
    [theme.fn.smallerThan(1301)]: {
      width: '620px',
    },
    [theme.fn.smallerThan(1250)]: {
      width: '620px',
    },
    [theme.fn.smallerThan(1225)]: {
      width: '605px',
    },
    [theme.fn.smallerThan(1215)]: {
      width: '600px',
    },
    [theme.fn.smallerThan(1200)]: {
      width: '460px',
    },
    [theme.fn.smallerThan(1175)]: {
      width: '450px',
    },
    [theme.fn.smallerThan(1150)]: {
      width: '440px',
    },
    [theme.fn.smallerThan(1125)]: {
      width: '430px',
    },
    [theme.fn.smallerThan(1100)]: {
      width: '420px',
    },
    [theme.fn.smallerThan(1085)]: {
      width: '410px',
    },
    [theme.fn.smallerThan(1060)]: {
      width: '400px',
    },
    [theme.fn.smallerThan(1050)]: {
      width: '390px',
    },
    [theme.fn.smallerThan(1025)]: {
      width: '380px',
    },
    [theme.fn.smallerThan(993)]: {
      left: 210,
      width: '595px',
    },
    [theme.fn.smallerThan(970)]: {
      width: '565px',
    },
    [theme.fn.smallerThan(950)]: {
      width: '555px',
    },
    [theme.fn.smallerThan(940)]: {
      width: '545px',
    },
    [theme.fn.smallerThan(920)]: {
      width: '525px',
    },
    [theme.fn.smallerThan(895)]: {
      width: '490px',
    },
    [theme.fn.smallerThan(870)]: {
      width: '470px',
    },
    [theme.fn.smallerThan(845)]: {
      width: '450px',
    },
    [theme.fn.smallerThan(825)]: {
      width: '430px',
    },
    [theme.fn.smallerThan(813)]: {
      width: '415px',
    },
    [theme.fn.smallerThan(800)]: {
      width: '400px',
    },
    [theme.fn.smallerThan(775)]: {
      width: '380px',
    },
    [theme.fn.smallerThan(765)]: {
      width: '370px',
    },
    [theme.fn.smallerThan(750)]: {
      width: '360px',
    },
    [theme.fn.smallerThan(740)]: {
      width: '347px',
    },
    [theme.fn.smallerThan(730)]: {
      width: '335px',
    },
    [theme.fn.smallerThan(710)]: {
      width: '310px',
    },
    [theme.fn.smallerThan(695)]: {
      width: '295px',
    },
    [theme.fn.smallerThan(680)]: {
      width: '280px',
    },
    [theme.fn.smallerThan(665)]: {
      width: '265px',
    },
    [theme.fn.smallerThan(641)]: {
      left: 85,
      top: 23,
      width: '370px',
    },
    [theme.fn.smallerThan(625)]: {
      width: '365px',
    },
    [theme.fn.smallerThan(605)]: {
      width: '345px',
    },
    [theme.fn.smallerThan(590)]: {
      width: '330px',
    },
    [theme.fn.smallerThan(575)]: {
      width: '320px',
    },
    [theme.fn.smallerThan(567)]: {
      width: '313px',
    },
    [theme.fn.smallerThan(560)]: {
      width: '300px',
    },
    [theme.fn.smallerThan(552)]: {
      width: '295px',
    },
    [theme.fn.smallerThan(545)]: {
      width: '290px',
    },
    [theme.fn.smallerThan(538)]: {
      width: '284px',
    },
    [theme.fn.smallerThan(530)]: {
      width: '265px',
    },
    [theme.fn.smallerThan(515)]: {
      width: '258px',
    },
    [theme.fn.smallerThan(508)]: {
      width: '252px',
    },
    [theme.fn.smallerThan(500)]: {
      width: '243px',
    },
    [theme.fn.smallerThan(485)]: {
      width: '225px',
    },
    [theme.fn.smallerThan(475)]: {
      width: '210px',
    },
    [theme.fn.smallerThan(460)]: {
      width: '200px',
    },
    [theme.fn.smallerThan(450)]: {
      width: '185px',
    },
    [theme.fn.smallerThan(435)]: {
      width: '175px',
    },
    [theme.fn.smallerThan(427)]: {
      width: '170px',
    },
    [theme.fn.smallerThan(420)]: {
      width: '160px',
    },
    [theme.fn.smallerThan(410)]: {
      width: '155px',
    },
    [theme.fn.smallerThan(401)]: {
      top: 21,
      fontSize: '12px',
      width: '160px',
    },
    [theme.fn.smallerThan(390)]: {
      width: '150px',
    },
    [theme.fn.smallerThan(380)]: {
      width: '140px',
    },
    [theme.fn.smallerThan(370)]: {
      width: '130px',
    },
    [theme.fn.smallerThan(360)]: {
      width: '120px',
    },
    [theme.fn.smallerThan(355)]: {
      width: '145px',
    },
    [theme.fn.smallerThan(345)]: {
      width: '137px',
    },
    [theme.fn.smallerThan(337)]: {
      width: '130px',
    },
    [theme.fn.smallerThan(330)]: {
      width: '120px',
    },
    [theme.fn.smallerThan(325)]: {
      width: '120px',
    },
    [theme.fn.smallerThan(320)]: {
      width: '110px',
    },
    [theme.fn.smallerThan(310)]: {
      width: '100px',
    },
    [theme.fn.smallerThan(300)]: {
      width: '90px',
    },
    [theme.fn.smallerThan(285)]: {
      width: '80px',
    },
    [theme.fn.smallerThan(275)]: {
      width: '75px',
    },
  },
  animatedSongName_PwaInstall_Shown: {
    zIndex: 1,
    position: 'absolute',
    left: 305,
    top: 22,
    fontStyle: 'italic',
    width: '1075px',
    height: '30px',
    [theme.fn.smallerThan(2166)]: {
      width: '1140px',
    },
    [theme.fn.smallerThan(2135)]: {
      width: '1135px',
    },
    [theme.fn.smallerThan(2100)]: {
      width: '1085px',
    },
    [theme.fn.smallerThan(2075)]: {
      width: '1070px',
    },
    [theme.fn.smallerThan(2050)]: {
      width: '1060px',
    },
    [theme.fn.smallerThan(2025)]: {
      width: '1040px',
    },
    [theme.fn.smallerThan(2001)]: {
      width: '985px',
    },
    [theme.fn.smallerThan(1975)]: {
      width: '970px',
    },
    [theme.fn.smallerThan(1950)]: {
      width: '960px',
    },
    [theme.fn.smallerThan(1925)]: {
      width: '940px',
    },
    [theme.fn.smallerThan(1900)]: {
      width: '880px',
    },
    [theme.fn.smallerThan(1850)]: {
      width: '870px',
    },
    [theme.fn.smallerThan(1820)]: {
      width: '850px',
    },
    [theme.fn.smallerThan(1801)]: {
      width: '790px',
    },
    [theme.fn.smallerThan(1750)]: {
      width: '750px',
    },
    [theme.fn.smallerThan(1725)]: {
      width: '735px',
    },
    [theme.fn.smallerThan(1700)]: {
      width: '730px',
    },
    [theme.fn.smallerThan(1686)]: {
      width: '665px',
    },
    [theme.fn.smallerThan(1656)]: {
      width: '645px',
    },
    [theme.fn.smallerThan(1600)]: {
      width: '625px',
    },
    [theme.fn.smallerThan(1591)]: {
      width: '575px',
    },
    [theme.fn.smallerThan(1550)]: {
      width: '555px',
    },
    [theme.fn.smallerThan(1525)]: {
      width: '525px',
    },
    [theme.fn.smallerThan(1500)]: {
      width: '515px',
    },
    [theme.fn.smallerThan(1475)]: {
      width: '505px',
    },
    [theme.fn.smallerThan(1450)]: {
      width: '490px',
    },
    [theme.fn.smallerThan(1401)]: {
      width: '460px',
    },
    [theme.fn.smallerThan(1375)]: {
      width: '450px',
    },
    [theme.fn.smallerThan(1351)]: {
      width: '425px',
    },
    [theme.fn.smallerThan(1335)]: {
      width: '410px',
    },
    [theme.fn.smallerThan(1325)]: {
      width: '405px',
    },
    [theme.fn.smallerThan(1301)]: {
      width: '650px',
    },
    [theme.fn.smallerThan(1275)]: {
      width: '625px',
    },
    [theme.fn.smallerThan(1250)]: {
      width: '620px',
    },
    [theme.fn.smallerThan(1225)]: {
      width: '605px',
    },
    [theme.fn.smallerThan(1215)]: {
      width: '600px',
    },
    [theme.fn.smallerThan(1200)]: {
      width: '460px',
    },
    [theme.fn.smallerThan(1175)]: {
      width: '450px',
    },
    [theme.fn.smallerThan(1150)]: {
      width: '440px',
    },
    [theme.fn.smallerThan(1125)]: {
      width: '430px',
    },
    [theme.fn.smallerThan(1100)]: {
      width: '420px',
    },
    [theme.fn.smallerThan(1085)]: {
      width: '410px',
    },
    [theme.fn.smallerThan(1060)]: {
      width: '400px',
    },
    [theme.fn.smallerThan(1050)]: {
      width: '390px',
    },
    [theme.fn.smallerThan(1025)]: {
      width: '380px',
    },
    [theme.fn.smallerThan(993)]: {
      left: 210,
      width: '595px',
    },
    [theme.fn.smallerThan(970)]: {
      width: '565px',
    },
    [theme.fn.smallerThan(950)]: {
      width: '555px',
    },
    [theme.fn.smallerThan(940)]: {
      width: '545px',
    },
    [theme.fn.smallerThan(920)]: {
      width: '525px',
    },
    [theme.fn.smallerThan(895)]: {
      width: '490px',
    },
    [theme.fn.smallerThan(870)]: {
      width: '470px',
    },
    [theme.fn.smallerThan(845)]: {
      width: '450px',
    },
    [theme.fn.smallerThan(825)]: {
      width: '430px',
    },
    [theme.fn.smallerThan(813)]: {
      width: '415px',
    },
    [theme.fn.smallerThan(800)]: {
      width: '400px',
    },
    [theme.fn.smallerThan(775)]: {
      width: '380px',
    },
    [theme.fn.smallerThan(765)]: {
      width: '370px',
    },
    [theme.fn.smallerThan(750)]: {
      width: '360px',
    },
    [theme.fn.smallerThan(740)]: {
      width: '347px',
    },
    [theme.fn.smallerThan(730)]: {
      width: '335px',
    },
    [theme.fn.smallerThan(710)]: {
      width: '310px',
    },
    [theme.fn.smallerThan(695)]: {
      width: '295px',
    },
    [theme.fn.smallerThan(680)]: {
      width: '280px',
    },
    [theme.fn.smallerThan(665)]: {
      width: '265px',
    },
    [theme.fn.smallerThan(641)]: {
      left: 85,
      top: 23,
      width: '370px',
    },
    [theme.fn.smallerThan(625)]: {
      width: '350px',
    },
    [theme.fn.smallerThan(605)]: {
      width: '340px',
    },
    [theme.fn.smallerThan(590)]: {
      width: '330px',
    },
    [theme.fn.smallerThan(575)]: {
      width: '310px',
    },
    [theme.fn.smallerThan(567)]: {
      width: '303px',
    },
    [theme.fn.smallerThan(560)]: {
      width: '290px',
    },
    [theme.fn.smallerThan(552)]: {
      width: '295px',
    },
    [theme.fn.smallerThan(545)]: {
      width: '290px',
    },
    [theme.fn.smallerThan(538)]: {
      width: '274px',
    },
    [theme.fn.smallerThan(530)]: {
      width: '255px',
    },
    [theme.fn.smallerThan(515)]: {
      width: '248px',
    },
    [theme.fn.smallerThan(508)]: {
      width: '242px',
    },
    [theme.fn.smallerThan(500)]: {
      width: '233px',
    },
    [theme.fn.smallerThan(485)]: {
      width: '225px',
    },
    [theme.fn.smallerThan(475)]: {
      width: '210px',
    },
    [theme.fn.smallerThan(460)]: {
      width: '200px',
    },
    [theme.fn.smallerThan(450)]: {
      width: '185px',
    },
    [theme.fn.smallerThan(435)]: {
      width: '175px',
    },
    [theme.fn.smallerThan(427)]: {
      width: '170px',
    },
    [theme.fn.smallerThan(420)]: {
      width: '160px',
    },
    [theme.fn.smallerThan(410)]: {
      width: '155px',
    },
    [theme.fn.smallerThan(401)]: {
      top: 21,
      fontSize: '12px',
      width: '160px',
    },
    [theme.fn.smallerThan(390)]: {
      width: '150px',
    },
    [theme.fn.smallerThan(380)]: {
      width: '140px',
    },
    [theme.fn.smallerThan(370)]: {
      width: '130px',
    },
    [theme.fn.smallerThan(360)]: {
      width: '120px',
    },
    [theme.fn.smallerThan(355)]: {
      width: '145px',
    },
    [theme.fn.smallerThan(345)]: {
      width: '137px',
    },
    [theme.fn.smallerThan(337)]: {
      width: '130px',
    },
    [theme.fn.smallerThan(330)]: {
      width: '120px',
    },
    [theme.fn.smallerThan(320)]: {
      width: '110px',
    },
    [theme.fn.smallerThan(310)]: {
      width: '100px',
    },
    [theme.fn.smallerThan(300)]: {
      width: '90px',
    },
    [theme.fn.smallerThan(285)]: {
      width: '80px',
    },
    [theme.fn.smallerThan(275)]: {
      width: '75px',
    },
  },
  asianTextBlock: {
    whiteSpace: 'nowrap',
  },
  marqueeSpangStatic: {
    display: 'inline-block',
    transform: 'translate(30px, 0px)',
    [theme.fn.smallerThan(1800)]: {
      transform: 'translate(25px, 0px)',
    },
    [theme.fn.smallerThan(700)]: {
      transform: 'translate(15x, 0px)',
    },
    [theme.fn.smallerThan(500)]: {
      transform: 'translate(10px, 0px)',
    },
  },
}))
